export let verboseLoggingEnabled = false;

export function setVerboseLogging(enabled: boolean) {
  verboseLoggingEnabled = enabled;
}

const originalConsoleLog = console.log;
const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;

export function initLogger() {
  console.log = (...args: any[]) => {
    originalConsoleLog(...args);
    logMessageToLocalStorage(formatMessage(...args));
  };

  console.warn = (...args: any[]) => {
    originalConsoleWarn(...args);
    logMessageToLocalStorage('[WARN] ' + formatMessage(...args));
  };

  console.error = (...args: any[]) => {
    originalConsoleError(...args);
    logMessageToLocalStorage('[ERROR] ' + formatMessage(...args));
  };

  window.onerror = (_message, _source, _lineno, _colno, error) => {
    logMessageToLocalStorage('[UNCAUGHT] ' + (error?.stack || String(error)));
  };

  window.onunhandledrejection = (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    logMessageToLocalStorage('[UNHANDLED REJECTION] ' + (reason?.stack || String(reason)));
  };
}

export function downloadLogsUtil() {
  const logs = localStorage.getItem('logs') || '';
  const blob = new Blob([logs], { type: 'text/plain' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'BBMO.log';
  link.click();
}

function formatMessage(...args: any[]): string {
  try {
    const message = args.map(arg => {
      if (arg instanceof Error || arg instanceof DOMException) {
        return `${arg.name}: ${arg.message}`;
      }
      return typeof arg === 'object' ? JSON.stringify(arg) : String(arg);
    }).join(' ');
    return message;
  }
  catch (error) {
    originalConsoleError('Error formatting message:', error);
    return 'Error formatting message';
  }
}

function logMessageToLocalStorage(message: string) {
  const timestamp = new Date().toISOString();
  const logEntry = `${timestamp} - ${message}\n`;

  const existingLogs = localStorage.getItem('logs') || '';
  localStorage.setItem('logs', existingLogs + logEntry);
}
